const log = require('bows')('socket.js', '[FE]')

class CobrowsingSocket {
  constructor() {
    this.socket = null
    this.socketConn = false
    this.mainEv = null
    this.isMaster = false
    this.haveControl = true
    this.socketHost = null
    this.room = null
    this.code = null
    this.isStreamOpen = false

    // callback to replace when the function is called
    var tempCallback = data => {
      log('temp callback', data)
    }
    this.forceview = tempCallback
    this.goto = tempCallback
    this.showpopup = tempCallback
    this.closepopup = tempCallback
    this.takecontrol = tempCallback
    this.streamopen = tempCallback

    window.onunload = () => {
      this.end()
    }
  }

  // PUBLIC UTILITY FUNCTIONS

  // connect to socket
  connect(param) {
    let timerConn = setInterval(() => {
      if (!param.socketHost) throw Error('Socket not defined')
      else {
        if (!this.socketHost) {
          this.socketHost = param.socketHost
          let recaptchaScript = document.createElement('script')
          recaptchaScript.setAttribute('src', '/ws/socket.io.js')
          document.getElementsByTagName('head')[0].appendChild(recaptchaScript)
        }
        if (typeof window.io != 'undefined') {
          clearInterval(timerConn)
          this.socket = window.io(param.socketHost, { path: '/ws' })
          this.socket.on('connect', () => {
            this.socketConnect(param)
          })
          this.socket.on('disconnect', () => {
            this.socketDisconnect(param)
          })
        }
      }
    }, 200)
  }

  // close socket connection
  end() {
    // TODO: GESTIRE APERTURA / CHIUSURA
    // if (!this.isMaster) this.sktEmit('peer', { op: 'stop' })

    this.sktEmit('logout', {code: this.code})

    if (this.socket) this.socket.close()
  }

  // send camera view data to other peer
  streamViewSend(data) {
    const sendData = {hlookat: data.hlookat, vlookat: data.vlookat}
    log('sending camera view data', sendData)
    if (this.isStreamOpen) this.sktEmit('view', {room: this.room, data: sendData })
  }

  // send viewpoint data to other peer
  streamPosSend(data) {
    log('sending viewpoint data', data)
    if (this.isStreamOpen) this.sktEmit('position', {room: this.room, data })
  }

  // take control of the tour
  takeControl() {
    log('taking control')
    this.haveControl = true
    if (this.isStreamOpen) this.sktEmit('control', {room: this.room, data: !this.haveControl })
  }

  // yield control of the tour
  yieldControl() {
    log('yield control')
    this.haveControl = false
    if (this.isStreamOpen) this.sktEmit('control', {room: this.room, data: !this.haveControl })
  }

  // CALLBACK INVOKING FUNCTIONS

  $emit(operation, data) {
    if (this[operation]) {
      this[operation](data)
    } else {
      log('Operation ' + operation + ' not defined')
    }
  }

  sktEmit(act, data) {
    if (this.socketConn) this.socket.emit(act, data)
  }

  // init and terminate function, assign the correct callback and call initPc
  init() {
    this.socket.on('start', this.onStart)
    this.socket.on('view', this.onStreamViewReceive)
    this.socket.on('position', this.onStreamPosReceive)
    this.socket.on('popupOpen', this.onPopupHotspotReceive)
    this.socket.on('popupClose', this.onPopupButtonCloseClickReceive)
    this.socket.on('control', this.onHaveControlReceive)
  }

  terminate(){
    this.socket.off('start', this.onStart)
    this.socket.off('view', this.onStreamViewReceive)
    this.socket.off('position', this.onStreamPosReceive)
    this.socket.off('popupOpen', this.onPopupHotspotReceive)
    this.socket.off('popupClose', this.onPopupButtonCloseClickReceive)
    this.socket.off('control', this.onHaveControlReceive)
  }

  // Socket functions (callback)

  socketConnect = param => {
    this.socketConn = true
    this.room = param.room
    this.code = param.code
    this.sktEmit('login', param)
    this.init()
    log('SOCKET CONNECTION COMPLETED')
  }

  socketDisconnect = () => {
    this.terminate()
    this.socketConn = false
    this.isStreamOpen = false
    this.room = null
    this.code = null
    this.haveControl = true
    log('SOCKET DISCONNECTED')
  }

  // Cobrowsing function

  onStart = () => {
    this.isStreamOpen = true
    this.streamopen()
    
  }

  onStreamViewReceive = res => {
    log('receive view', res)
    this.$emit('forceview', res.data)
  }

  onStreamPosReceive = res => {
    log('receive pos', res)
    this.$emit('goto', res.data)
  }

  onStreamViewSend = data => {
    if (this.haveControl && this.isStreamOpen) {
      const sendData = {hlookat: data.hlookat, vlookat: data.vlookat}
      log('send view', sendData)
      if (this.haveControl){
      this.sktEmit('view', {room: this.room, data: sendData })
      }
    }
  }

  onStreamPosSend = data => {
    if (this.haveControl && this.isStreamOpen) {
      log('send pos', data)
      if (this.haveControl){
      this.sktEmit('position', {room: this.room, data })
      }
    }
  }

  onPopupHotspotReceive = res => {
    this.$emit('showpopup', res.data)
  }

  popupHotspotSend = data => {
    if (this.haveControl && this.isStreamOpen)
    this.sktEmit('popupOpen', {room: this.room, data })
  }

  onPopupButtonCloseClickReceive = () => {
    this.$emit('closepopup')
  }

  onPopupButtonCloseSend = () => {
    if (this.haveControl && this.isStreamOpen)
    this.sktEmit('popupClose', {room: this.room })
  }

  onHaveControlReceive = res => {
    log('received control', res)
    this.haveControl = typeof res.data === 'boolean' ? res.data : !this.haveControl
    this.takecontrol(this.haveControl)
  }
}

export default CobrowsingSocket
